import { useMemo } from 'react';
import styled from 'styled-components';
import { TPaymentPeriodPayment } from '../../../../../types/payment-data-types';
import { ILineItem, IProvider } from '../../../../../types/tax-summary-types';
import { TSupportedLocales } from '../../../utils';
import { PaymentPeriodSummary } from './tax-summary-table';

const TaxSummaryContainer = styled.div.attrs({
  className: 'taxSummaryContainer'
})`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 30px 20px;
`;

/**
 * This is a reduced and modified version of the same component used in the Pay flow of the reg system.
 * This component is not meant to be used as a replacement for the one in the reg system, but rather a component
 * specifically for the reporting history display in the customer portal.
 */
export function TaxSummary(props: {
  providers: IProvider[];
  lineItems: ILineItem[];
  locale: TSupportedLocales;
  paymentData: TPaymentPeriodPayment;
}) {
  const { providers, lineItems, paymentData } = props;

  const {
    providerLineItems,
    providerOrder,
  } = useMemo(() => ({
    providerLineItems: providers.map(({ label }) => label),
    providerOrder: providers.map(({ provider }) => provider),
  }), [providers]);

  return (
    <TaxSummaryContainer>
      <PaymentPeriodSummary
        locale={props.locale}
        data={paymentData}
        providerLineItems={providerLineItems}
        providerOrder={providerOrder}
        lineItems={lineItems}
      />
    </TaxSummaryContainer>
  );
}